export const actionTypes = {
  SHOW_CANCEL_REASON_DIALOG: 'SHOW_CANCEL_REASON_DIALOG',
  HIDE_CANCEL_REASON_DIALOG: 'HIDE_CANCEL_REASON_DIALOG',
};

const showCancelReasonDialog = ({ orderId }) => ({
  type: actionTypes.SHOW_CANCEL_REASON_DIALOG,
  payload: {
    orderId,
  },
});

const hideCancelReasonDialog = () => ({
  type: actionTypes.HIDE_CANCEL_REASON_DIALOG,
});

export { showCancelReasonDialog, hideCancelReasonDialog };
